"use client";
import Card from "../Card";
import { Button } from "@/components/ui/button";
import { useClientTranslation } from "@/app/i18n/client";
import { useSite } from "@/lib/hooks/site";
import { useTranslation } from "@/hooks/translationContext";

//@ts-ignore

export default function Cards() {
  const { t } = useTranslation()
  const site = useSite();
  const cardItems = [
    {
      image: site.setting?.design?.addVenue?.adv?.firstPhoto?.["1"] ? `site/${site.id}/assets/${site.setting?.design?.addVenue?.adv?.firstPhoto?.["1"]}` : null,
      title: t("add-venue-page-first-advantage-card-title", { defaultValue: "Google’da en üstte olun!" })
    },
    {
      image: site.setting?.design?.addVenue?.adv?.secondPhoto?.["1"] ? `site/${site.id}/assets/${site.setting?.design?.addVenue?.adv?.secondPhoto?.["1"]}` : null,
      title: t("add-venue-page-second-advantage-card-title", { defaultValue: "400 bin ziyaretçi ve rakipleriniz burada!" }),
    },
    {
      image: site.setting?.design?.addVenue?.adv?.thirdPhoto?.["1"] ? `site/${site.id}/assets/${site.setting?.design?.addVenue?.adv?.thirdPhoto?.["1"]}` : null,
      title: t("add-venue-page-offer-advantage-card-title"),
    },
    {
      image: site.setting?.design?.addVenue?.adv?.fourthPhoto?.["1"] ? `site/${site.id}/assets/${site.setting?.design?.addVenue?.adv?.fourthPhoto?.["1"]}` : null,
      title: t("add-venue-page-fourth-advantage-card-title", { defaultValue: "İşletmenizi Büyütün!" }),
    },
  ];

  return (
    <div className="container flex flex-col items-center gap-6">
      <div className="mt-[14px] w-full flex gap-5 flex-wrap md:flex-row flex-col items-center justify-between">
        {cardItems.map((item, index) => {
          return <Card {...item} count={index} key={index} />;
        })}
      </div>

      <Button
        onClick={() => {
          window.scrollTo({
            top: 0,
          });
        }}
        className="bg-[#15BBAE] hover:bg-[#15BBAE] "
      >
        {t("venue-add-title", {
          defaultValue: "Mekan Ekle",
        })}
      </Button>
    </div>
  );
}
